import { Injectable, TemplateRef } from '@angular/core';
import { throwError, Observable } from 'rxjs';
import { isNullOrUndefined } from '../../app/core/utils';
import { EosApiException } from './api.gen';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor() { }

  toasts: any[] = [];

  /**
  * Shows a toast message by default as a neutral information
  */
  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    const defaultOptions = {
      classname: 'alert-info toast-info',
      delay: 5000,
      autohide: false,
      closebtn: true,
      // headertext:""
    };
    const mergedOption = { ...defaultOptions, ...options };
    this.toasts.push({ textOrTpl, ...mergedOption });
  }

  success(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    const defaultOptions = {
      classname: 'alert-success toast-success',
      delay: 5000,
      autohide: true,
      closebtn: true,
      // headertext:""
    };
    const mergedOption = { ...defaultOptions, ...options };
    this.toasts.push({ textOrTpl, ...mergedOption });
  }
 successImmReports(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    const defaultOptions = {
      classname: 'alert-success toast-success',
      delay: 10000,
      autohide: true,
      closebtn: true,
      // headertext:""
    };
    const mergedOption = { ...defaultOptions, ...options };
    this.toasts.push({ textOrTpl, ...mergedOption });
  }
  error(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    const defaultOptions = {
      classname: 'alert-danger toast-danger',
      delay: 5000,
      autohide: true,
      closebtn: true,
      // headertext:""
    };
    const mergedOption = { ...defaultOptions, ...options };
    this.toasts.push({ textOrTpl, ...mergedOption });
  }

  serverError(err: EosApiException, defaultMessage = 'Something went wrong!') {
    if (err instanceof EosApiException && err.type === 'eos-ex') {
      if (!isNullOrUndefined(err.errorCode)) {
        this.error(`${err.errorInfo} (code:${err.errorCode})`);
      } else {
        this.error(`${err.errorInfo}`);
      }
      return;
    }
    this.error(defaultMessage);
  }

  warning(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    const defaultOptions = {
      classname: 'alert-warning  toast-warning',
      delay: 5000,
      autohide: true,
      // headertext:""
      closebtn: true,
    };
    const mergedOption = { ...defaultOptions, ...options };
    this.toasts.push({ textOrTpl, ...mergedOption });
  }

  documentValidations(textOrTpl: string[] | TemplateRef<any>, options: any = {}) {
    const defaultOptions = {
      classname: 'alert-warning  toast-warning',
      delay: 15000,
      autohide: true,
      // headertext:""
      closebtn: true,
    };
    const mergedOption = { ...defaultOptions, ...options };
    this.toasts.push({ textOrTpl, ...mergedOption });
  }


  handleServerValidationMessage(error: any): Observable<never> {
    if (error && error.status === 400) {
      // this.warning(error.response);
      this.warning(`Validation failure: ${error.response}`);
    }
    return throwError(error);
  }


  remove(toast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }

}
